import { createReducer, on } from "@ngrx/store";
import {
  Pagination,
  SubscriptionOrganization,
} from "src/app/shared/interfaces/orgadmin/course-organization";

import { HttpErrorResponse } from "@angular/common/http";
import {
  coursesAdminListLoad,
  coursesAdminListLoadSuccess,
  coursesAdminReset,
  loadTeachersFailure,
  updateActiveTeachersSubgroup,
} from "../../actions/admin/course-admin.actions";
import { RequestStatus } from "src/app/shared/interfaces/request-status";
import { createEntityAdapter, EntityState } from "@ngrx/entity";

export interface AdminCourseList {
  subscriptions: EntityState<SubscriptionOrganization>;
  pagination: Pagination | null;
  status: RequestStatus;
  error: HttpErrorResponse | null;
}

export interface AdminCourseListState {
  active: AdminCourseList;
  inactive: AdminCourseList;
  orgId: string | null;
  search: string | null;
}

export const activeCourseAdapter =
  createEntityAdapter<SubscriptionOrganization>();
export const inactiveCourseAdapter =
  createEntityAdapter<SubscriptionOrganization>();

const initialState: AdminCourseListState = {
  orgId: null,
  search: null,
  active: {
    subscriptions: activeCourseAdapter.getInitialState(),
    pagination: {
      next: 0,
      page_count: 0,
      previous: 0,
      result_count: 0,
    },
    error: null,
    status: "IDLE",
  },
  inactive: {
    subscriptions: inactiveCourseAdapter.getInitialState(),
    pagination: {
      next: 0,
      page_count: 0,
      previous: 0,
      result_count: 0,
    },
    error: null,
    status: "IDLE",
  },
};

export const adminCourseListReducer = createReducer(
  initialState,
  on(coursesAdminListLoad, (state, action): AdminCourseListState => {
    let key: "active" | "inactive" = action.active ? "active" : "inactive";
    return {
      ...state,
      [key]: {
        ...state[key],
        pagination: null,
        error: null,
        status: "PENDING",
      },
      orgId: null,
      search: action.search,
    };
  }),
  on(coursesAdminListLoadSuccess, (state, action): AdminCourseListState => {
    let { results, ...pagination } = action.coursesList;
    let key: "active" | "inactive" = action.active ? "active" : "inactive";
    return {
      ...state,
      [key]: {
        ...state[key],
        subscriptions: action.active
          ? activeCourseAdapter.upsertMany(results, state.active.subscriptions)
          : inactiveCourseAdapter.upsertMany(
              results,
              state.inactive.subscriptions,
            ),
        pagination,
        error: null,
        status: "SUCCESS",
      },
      search: action.search,
      orgId: action.orgId,
    };
  }),
  on(loadTeachersFailure, (state, { error }) => ({
    ...state,
    error,
    status: "FAILED",
  })),
  on(coursesAdminReset, (state, action): AdminCourseListState => {
    let key: "active" | "inactive" = action.active ? "active" : "inactive";
    return { ...state, [key]: initialState[key] };
  }),
  on(updateActiveTeachersSubgroup, (state, { teachers, courseAdminId }) => {
    let subCourse = state.active.subscriptions.entities[courseAdminId];
    if (!subCourse) return state;
    return {
      ...state,
      active: {
        ...state.active,
        subscriptions: activeCourseAdapter.upsertOne(
          {
            ...subCourse,
            subgroups: subCourse.subgroups.map((subgroup) =>
              subgroup.id === teachers.id ? teachers : subgroup,
            ),
          },
          state.active.subscriptions,
        ),
      },
    };
  }),
);
